import React from 'react';
import {RaisedButton, SelectField, Snackbar} from "material-ui";
import {Link, withRouter} from "react-router-dom";
import {trim, get} from "lodash";
import {validateEmail} from "../helpers";
import {createSubscriber} from "../actions/lead";
import {connect} from "react-redux";
import JdData from './JdData'
import EmiInput from './EmiInput';
import { INTEREST_TYPE } from '../constants/common';
import { MenuItem } from 'material-ui/Menu';
import { CardActions } from 'material-ui/Card';

class JobDescription extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            loanAmount: 100000,
            interestType: 'Flat',
            interestRate: 12,
            tenure: 18,
            emi: '',
        }
    }
   

    validate = () => {
        return true
    }
  calculateEMI = async() => {
    if(this.validate()){
        if(this.state.interestType === 'Reducing') {
            const loanAmount = parseFloat(this.state.loanAmount) 
            const reducingRate = parseFloat(this.state.interestRate)/(12*100)
            const tenure = parseFloat(this.state.tenure)
            const emi = Math.round((loanAmount * reducingRate * Math.pow(1 + reducingRate, tenure))  / (Math.pow(1 + reducingRate, tenure) - 1)); 
            await this.setState({
                emi : emi.toString()
            }) 
        } else {
            const loanAmount = parseFloat(this.state.loanAmount) 
            const interestRatePerMonth = (parseFloat(this.state.interestRate)/(12*100))
            const tenure = parseFloat(this.state.tenure)
            const totalInterest = (loanAmount * interestRatePerMonth * tenure)

            const emi = Math.round((parseInt(loanAmount) + totalInterest) / tenure)
            await this.setState({
                emi : emi.toString()
            }) 
        }
        
    }
}

handleEmiCalculatorChange = async(name, value) => {
    await this.setState({ [name]: value });
    await this.calculateEMI()
  };

  componentDidMount = () => {
    this.calculateEMI()
  }

    render() {
        return (
            <div style={{ padding: '0px', position: 'relative', color: 'white' }}>
            <h6 style={{textAlign : 'center',fontFamily: 'Open Sans', color: 'white'}}>EMI CALCULATOR</h6>
          {/* <IconButton
            onClick={this.handleClose}
            style={{ position: 'absolute', right: '0px', top: '-10px', zIndex: 100,backgroundColor : 'white',color : 'black',borderRadius : '16px',fontSize : '20px'}}
          >
            <i style={{ color: 'white', fontSize: '0px',padding : '0' }} className="fa fa-close cursor_pointer"></i>
          </IconButton> */}

          <div style={{ lineHeight: 1.4,marginTop : '0px',width : '50%',margin : '0 auto' }}>
          <CardActions>
              <SelectField
                floatingLabelText="Interest Type*"
                value={this.state.interestType}
                onChange={(event, index, value) => this.handleEmiCalculatorChange('interestType', value)}
                floatingLabelFixed={true}
                style={{margin : '0px 0'}}
                labelStyle={{color: 'white'}}
                floatingLabelStyle={{color: 'white'}}
                iconStyle={{fill: 'white'}}
              >
                {INTEREST_TYPE.map((type) => (
                  <MenuItem key={type.value} value={type.value} primaryText={type.name} />
                ))}
              </SelectField>
            </CardActions>
            <EmiInput
              name="loanAmount"
              title="Loan Amount"
              value={this.state.loanAmount}
              min={10000}
              max={500000}
              step={1000}
              prefix={'₹'}
              position={88}
              handleChange={this.handleEmiCalculatorChange}
              indent={24}
            />
            <EmiInput
              name="interestRate"
              title="Interest Rate"
              value={this.state.interestRate}
              min={1}
              max={30}
              step={0.1}
              handleChange={this.handleEmiCalculatorChange}
              postfix={'% p.a.'}
              position={40}
              indent={10}
              inputWidth={'50px'}
            />

            <EmiInput
              name="tenure"
              title="Loan Tenure"
              value={this.state.tenure}
              min={1}
              max={60}
              step={1}
              handleChange={this.handleEmiCalculatorChange}
              postfix={'Month(s)'}
              position={38}
              indent={10}
              inputWidth={'50px'}
            />

            <p style={{fontSize : '16px',fontWeight : 'bold',letterSpacing : '2px',marginTop : '-24px', fontFamily: 'Open Sans', color: 'white'}}>Monthly EMI: <span style={{fontSize : '16px',fontWeight : 'bold',letterSpacing : '2px'}}>₹</span><span style={{fontSize : '18px',fontWeight : 'bold',letterSpacing : '2px'}}>{this.state.emi}</span></p>
          </div>

          {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
            <button
              style={{ color: 'white', backgroundColor: BUTTON_COLOR, padding: '12px 40px', textAlign: 'center', width: '40%' }}
              onClick={this.calculateEMI}
            >
              Calculate EMI
            </button>
          </div> */}
        </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    createSubscriber: body => dispatch(createSubscriber(body)),
});

export default withRouter(connect(null, mapDispatchToProps)(JobDescription))


// WEBPACK FOOTER //
// ./src/components/EmiCalculator.js